<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-07-13 09:17:17
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-02-09 17:30:59
-->

<template>
  <div class="pie">
    <!-- <div class="tab">
      <div :class="['tab-item', { active: type == 1 }]" @click="typeChange(1)">月</div>
      <div :class="['tab-item', { active: type == 2 }]" @click="typeChange(2)">季</div>
      <div :class="['tab-item', { active: type == 3 }]" @click="typeChange(3)">年</div>
    </div> -->
    <div class="title">
      <img src="@/img/datav/title_icon.png" alt="" />
      <span>产品类型销售额统计(万元)</span>
    </div>
    <vue-seamless-scroll :data="data" :class-option="scrollOption" class="progress-list">
      <div v-for="(item, index) in data" :key="index" class="progress-item">
        <div class="name">{{ item.typeName }}</div>
        <div class="progress-wrapper">
          <a-progress
            :stroke-color="getColor(index)"
            :show-info="false"
            :percent="(item.amount / max) * 100"
          />
          <div class="glow-bar" :style="{ width: (item.amount / max) * 100 + '%' }"></div>
        </div>
        <div class="price">
          <span class="num">{{ item.amount }}</span>
          <span class="unit">万元</span>
        </div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>
<script>
import { productSale } from '@/api/dashboard'
import to from 'await-to'

const colorMap = [
  { start: '#FEDB65', end: '#FFA803' },
  { start: '#2AD7FD', end: '#126DFF' },
  { start: '#6782F9', end: '#606FFE' },
  { start: '#0ED6D3', end: '#058BBC' },
  { start: '#FFD5B3', end: '#FFA45A' },
  { start: '#D5B7FF', end: '#864ED9' },
  { start: '#FD6759', end: '#FA2C19' },
]
export default {
  data() {
    return {
      type: 3,
      max: 92562,
      scrollOption: {
        step: 0.6,
        limitMoveNum: 4,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 0,
      },
      data: [
        {
          typeName: '蔬菜水果',
          amount: 0,
        },
        {
          typeName: '肉蛋家禽',
          amount: 0,
        },
        {
          typeName: '米面粮油',
          amount: 0,
        },
        {
          typeName: '鱼虾水产',
          amount: 0,
        },
        {
          typeName: '豆制品类',
          amount: 0,
        },
        {
          typeName: '菌菇干货',
          amount: 0,
        },
        {
          typeName: '茶叶醇香',
          amount: 0,
        },
        {
          typeName: '地方特色',
          amount: 0,
        },
      ],
    }
  },
  mounted() {
    this.initData()
    setInterval(() => {
      this.initData()
    }, process.env.VUE_APP_LTIME)
  },
  methods: {
    async initData() {
      const [res, err] = await to(productSale({ type: this.type }))
      if (err) return
      this.data = res.data
      this.max = Math.max(...res.data.map(item => item.amount))
    },
    getColor(index) {
      const colorIndex = Math.floor(Math.abs(index) % colorMap.length)
      const color = [colorMap[colorIndex]['start'], colorMap[colorIndex]['end']]
      return {
        '0%': color[0],
        '100%': color[1],
      }
    },
    typeChange(type) {
      this.type = type
      this.initData()
    },
  },
}
</script>
<style lang="scss" scoped>
.pie {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 10px 10px;
  .title {
    position: relative;
    font-size: 26px;
    color: #ecf8ff;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    img {
      margin-right: 3px;
    }
  }
  .tab {
    z-index: 99;
    position: absolute;
    right: 26px;
    top: 36px;
    display: flex;
    .tab-item {
      width: 64px;
      height: 31px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #15535e;
      text-align: center;
      line-height: 29px;
      color: rgba(255, 255, 255, 0.8);
      &.active {
        color: #66ffff;
      }
    }
  }
  .progress-list {
    padding-left: 8px;
    height: 400px;
    overflow: hidden;
    .progress-item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      line-height: 28px;
      padding: 14px 18px;
      background: linear-gradient(
        90deg,
        rgba(18, 109, 255, 0.15) 0%,
        rgba(18, 109, 255, 0.05) 50%,
        rgba(18, 109, 255, 0.02) 100%
      );
      border-left: 2px solid transparent;
      border-radius: 0 6px 6px 0;
      will-change: transform;
      transition: background-color 0.2s ease, border-color 0.2s ease;

      &:hover {
        background: linear-gradient(
          90deg,
          rgba(102, 255, 255, 0.2) 0%,
          rgba(18, 109, 255, 0.1) 50%,
          rgba(18, 109, 255, 0.05) 100%
        );
        border-left-color: rgba(102, 255, 255, 0.6);

        .rank-num:not(.top-three) {
          background: rgba(102, 255, 255, 0.2);
          color: #66ffff;
        }
      }

      .rank-num {
        width: 24px;
        height: 24px;
        min-width: 24px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.08);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        font-weight: 600;
        color: #6b7a94;
        margin-right: 12px;
        transition: background-color 0.2s ease, color 0.2s ease;
        font-family: 'Arial', sans-serif;

        &.top-three {
          background: linear-gradient(135deg, #ffd700 0%, #ffa500 100%);
          color: #1a1a2e;
        }
      }

      .name {
        font-size: 24px;
        color: #b8c5d8;
        margin-right: 16px;
        width: 140px;
        font-weight: 500;
        flex-shrink: 0;
      }

      .progress-wrapper {
        flex: 1;
        min-width: 0;
        padding-right: 15px;
        position: relative;

        ::v-deep.ant-progress {
          .ant-progress-inner {
            background-color: rgba(255, 255, 255, 0.06);
            border-radius: 10px;
          }
          .ant-progress-bg {
            height: 14px !important;
            border-radius: 10px !important;
          }
        }

        .glow-bar {
          position: absolute;
          top: 50%;
          left: 0;
          height: 1px;
          transform: translateY(-50%);
          background: linear-gradient(90deg, rgba(102, 255, 255, 0.5) 0%, transparent 100%);
          opacity: 0.4;
          pointer-events: none;
        }
      }

      .price {
        font-size: 22px;
        color: #66ffff;
        font-weight: 600;
        display: flex;
        align-items: baseline;
        font-family: 'Arial', sans-serif;
        width: 130px;
        flex-shrink: 0;
        justify-content: flex-end;

        .num {
          color: #66ffff;
        }

        .unit {
          font-size: 14px;
          color: #6b7a94;
          margin-left: 2px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
